import React, { useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

import { UserContext } from '~contexts/user';

import Form from '~components/forms/form';
import { PhoneInputControlled } from '~components/forms/phone-input';
import Button from '~components/button';

const PhoneForm = ({ onSubmit = () => {} }) => {
  const intl = useIntl();

  const { user, updateCustomer, updateWorker } = useContext(UserContext);

  // eslint-disable-next-line camelcase
  const phoneNumber = user.phoneNumber || '';

  const [isSubmitting, setIsSubmitting] = useState(false);

  const validationSchema = yup.object().shape({
    phoneNumber: yup.string().phoneNumber({ unique: true, ignoredPersonId: user.personId }),
  });

  const methods = useForm({
    mode: 'onSubmit',
    validationSchema,
    defaultValues: {
      phoneNumber: phoneNumber || '',
    },
  });

  const {
    getValues,
    errors,
    setError,
    formState: { dirtyFields },
  } = methods;

  const handleFormSubmit = async () => {
    if (!isEmpty(errors) || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    if (!dirtyFields.phoneNumber) {
      onSubmit(false);
      setIsSubmitting(false);
      return;
    }

    const formData = getValues();

    try {
      if (user.accountType === 'worker') {
        await updateWorker({ ...user, phoneNumber: formData.phoneNumber });
      } else {
        await updateCustomer({ ...user, phoneNumber: formData.phoneNumber });
      }

      setIsSubmitting(false);
      onSubmit(true);
    } catch (err) {
      setError('request', {
        type: 'manual',
        message: intl.formatMessage({
          id: `containers.account.phone.modal.form.update-error`,
          defaultMessage: 'Could not update phone number',
        }),
      });
      setIsSubmitting(false);
    }
  };

  return (
    <Form methods={methods} validationSchema={validationSchema} onSubmit={handleFormSubmit}>
      <div className="c-fieldset c-fieldset--modal">
        <div className="c-fieldset__label">
          {intl.formatMessage({
            id: 'containers.account.phone.modal.form.fields.phone-number.label',
            defaultMessage: 'Phone number',
          })}
        </div>
        <div className="c-fieldset__value">
          <PhoneInputControlled
            placeholder={intl.formatMessage({
              id: 'containers.account.phone.modal.form.fields.phone-number.placeholder',
              defaultMessage: 'Phone number',
            })}
            name="phoneNumber"
          />
        </div>
      </div>

      {methods.errors.request && <div className="c-form-error l-error">{methods.errors.request.message}</div>}

      <div className="c-fieldset">
        <div className="c-modal__buttons">
          <Button name="submit" type="submit" className="c-btn" disabled={!isEmpty(errors) || isSubmitting} isLoading={isSubmitting}>
            {intl.formatMessage({
              id: 'containers.account.phone.modal.form.save',
              defaultMessage: 'Save',
            })}
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default PhoneForm;
